// Constants for WebM file detection
const EBML_HEADER_BYTE_1 = 0x1a;
const EBML_HEADER_BYTE_2 = 0x45;
const EBML_HEADER_BYTE_3 = 0xdf;
const EBML_HEADER_BYTE_4 = 0xa3;
const EBML_HEADER = [EBML_HEADER_BYTE_1, EBML_HEADER_BYTE_2, EBML_HEADER_BYTE_3, EBML_HEADER_BYTE_4] as const;
const EBML_HEADER_LENGTH = EBML_HEADER.length;

// PNG magic number: 0x89 0x50 0x4E 0x47 0x0D 0x0A 0x1A 0x0A
const PNG_HEADER_BYTE_1 = 0x89;
const PNG_HEADER_BYTE_2 = 0x50;
const PNG_HEADER_BYTE_3 = 0x4e;
const PNG_HEADER_BYTE_4 = 0x47;
const PNG_HEADER = [PNG_HEADER_BYTE_1, PNG_HEADER_BYTE_2, PNG_HEADER_BYTE_3, PNG_HEADER_BYTE_4] as const;
const PNG_HEADER_LENGTH = PNG_HEADER.length;

/**
 * Detects if a file is a WebM format based on EBML header
 * @param uint8Array - The file data as Uint8Array
 * @returns true if the file is WebM format
 */
export const isWebMFile = (uint8Array: Uint8Array): boolean => {
  if (uint8Array.length < EBML_HEADER_LENGTH) return false;

  return EBML_HEADER.every((byte, index) => uint8Array[index] === byte);
};

/**
 * Detects if a file is a PNG format based on magic number
 * @param uint8Array - The file data as Uint8Array
 * @returns true if the file is PNG format
 */
export const isPngFile = (uint8Array: Uint8Array): boolean => {
  if (uint8Array.length < PNG_HEADER_LENGTH) return false;

  return PNG_HEADER.every((byte, index) => uint8Array[index] === byte);
};
